import React from 'react'
import Popup from 'reactjs-popup'
import { eFormButtonsContainer } from '../common/cssclasses'
import NewActionButton from './ActionButtons/NewActionButton'
import DraftBtn from './servicesButtons/DraftBtn'
import SubmitServiceBtn from './servicesButtons/SubmitServiceBtn'
import { useTranslate } from './TranslationText'

export default function CustomPopUp({ trigger, isPdf = false, isBid = false, title = "", content = "", onClick = "", btnText = "", disabled = false, goNext = false, onNext, onClose, ...props }) {
    const { translate } = useTranslate();

    async function doOnClick(e, close) {
        if (goNext) {
            onNext();
        } else {
            if (disabled) return;

            const result = await onClick(e);

            if (result === false) return;

            close();
        }

    }


    return (
        <Popup
            trigger={trigger}
            modal
            closeOnEscape={false}
            closeOnDocumentClick={false}
            lockScroll={true}
            overlayStyle={{ zIndex: 5000 }}
            contentStyle={{ maxWidth: '80%', minWidth: '300px', }}
            {...props}
        >
            {(close) =>
            (
                <>
                    {!!title &&
                        < h4 className='fw-bold'>
                            {title}
                        </h4>
                    }
                    {!!content &&
                        <div className='popUpElemnts mb-main' style={isBid ? { minHeight: 'unset', overflow: 'hidden' } : isPdf ? { height:'70vh' } : {}}>
                            {content}
                        </div>
                    }
                    <div className={eFormButtonsContainer}>
                        <DraftBtn
                            onClick={() => { onClose?.(); close() }}
                            text={translate('web.close', 'Close')}
                        />
                        {!!onClick &&
                            <SubmitServiceBtn text={btnText} key={'submit'} onClick={(e) => doOnClick(e, close)} disabled={disabled} />
                        }
                    </div>
                </>
            )

            }
        </Popup >
    )
}
